import React from 'react';
import { PriceDisplay } from './PriceDisplay';
export function ValueBreakdown() {
  const tomos = [{
    emoji: '📕',
    title: 'TOMO 01 — RESCATE 180 SEGUNDOS',
    value: 4990,
    bullets: ['12 recetas listas en 3 minutos.', 'La técnica del "Interruptor Proteico".', 'El mugcake que frena el antojo en 180 segundos.']
  }, {
    emoji: '📗',
    title: 'TOMO 02 — DULCES CERO CULPA ARGENTINA',
    value: 4990,
    bullets: ['Alfajor proteico, chocotorta fit, flan de vainilla y medialunas fit.', '25+ clásicos argentinos adaptados al Método.', 'Sin que nadie note la diferencia.']
  }, {
    emoji: '📘',
    title: 'TOMO 03 — CREMAS, HELADOS Y MOUSSES',
    value: 4990,
    bullets: ['Helado de chocolate con 3 ingredientes.', 'Mousse de dulce de leche en 5 minutos.', 'Paletas proteicas para tener en el freezer.']
  }, {
    emoji: '📙',
    title: 'TOMO 04 — PANADERÍA FIT & WHEY',
    value: 4990,
    bullets: ['Banana bread, muffins, brownies y cookies proteicas.', 'Pancakes para el desayuno del domingo.', 'El olor a recién horneado sin el pico de glucosa.']
  }, {
    emoji: '🏆',
    title: 'TOMO 05 — EL PROTOCOLO MAESTRO',
    value: 6990,
    bullets: ['El mecanismo del antojo explicado de una vez para siempre.', 'Planificador semanal de "Dulces Estratégicos".', 'El mapa completo para los primeros 21 días.', 'Sin este tomo tenés recetas. Con este tomo tenés un Sistema.']
  }];
  const bonuses = [{
    emoji: '🟣',
    title: 'BONO 01 — KIT RESCATE 11:11',
    value: 2990,
    bullets: ['7 recetas nocturnas en 5 minutos.', 'Tracker de 7 días de progreso.', 'Qué hacer exactamente a las 11pm.']
  }, {
    emoji: '🟢',
    title: 'BONO 02 — PLANTILLAS DE COMPRA',
    value: 1990,
    bullets: ['Lista semanal lista para usar.', 'Marcas argentinas con mejor relación calidad-precio.', 'Mapa de góndola para Carrefour, Coto y Disco.']
  }, {
    emoji: '🔴',
    title: 'BONO 03 — ANTI-GRUMOS & TEXTURA',
    value: 1990,
    bullets: ['Por qué la proteína se pone gomosa y cómo evitarlo.', 'Temperaturas exactas por preparación.', 'Tabla de sustituciones completa.']
  }, {
    emoji: '⚪',
    title: 'BONO 04 — HELADERA & FREEZER BLINDADOS',
    value: 1990,
    bullets: ['Qué preparar el domingo para 7 días resueltos.', 'Sistema de etiquetado por colores.', 'El "Tupper de Emergencia" para el trabajo.']
  }, {
    emoji: '🩶',
    title: 'BONO 05 — SCRIPTS & COPYS LISTOS',
    value: 1990,
    bullets: ['Qué decirle a tu familia.', 'Cómo manejarte en asados y reuniones.', 'Cómo decir "no" sin culpa.']
  }];
  return <section className="bg-chocolate-50 py-20 px-4" data-id="element-350">
      <div className="max-w-4xl mx-auto" data-id="element-351">
        <h2 className="text-3xl md:text-4xl font-bold text-chocolate-900 text-center mb-12" data-id="element-352">
          ¿Qué incluye EL MÉTODO ANTÍDOTO DULCE?
        </h2>
        <div className="space-y-6 mb-16" data-id="element-353">
          {tomos.map((tomo, idx) => <div key={idx} className="bg-white p-6 md:p-8 rounded-2xl shadow-md border-l-4 border-chocolate-900 flex flex-col md:flex-row gap-6" data-id="element-354">
              <div className="text-4xl flex-shrink-0" data-id="element-355">{tomo.emoji}</div>
              <div className="flex-grow" data-id="element-356">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-2" data-id="element-357">
                  <h3 className="text-xl font-bold text-chocolate-900" data-id="element-358">
                    {tomo.title}
                  </h3>
                  <span className="text-chocolate-800/60 font-medium" data-id="element-359">
                    Valor: <PriceDisplay amount={tomo.value} data-id="element-360" />
                  </span>
                </div>
                <ul className="space-y-2" data-id="element-361">
                  {tomo.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start space-x-2 text-chocolate-800" data-id="element-362">
                      <span className="text-gold-500 mt-1" data-id="element-363">•</span>
                      <span data-id="element-364">{bullet}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-10" data-id="element-365">
          <h3 className="text-3xl font-bold text-chocolate-900" data-id="element-366">
            Y además... los 5 bonos:
          </h3>
        </div>

        <div className="space-y-6" data-id="element-367">
          {bonuses.map((bono, idx) => <div key={idx} className="bg-gradient-to-br from-white to-gold-50/30 p-6 md:p-8 rounded-2xl shadow-lg border border-gold-400 flex flex-col md:flex-row gap-6 relative overflow-hidden" data-id="element-368">
              <div className="absolute top-0 right-0 bg-gold-500 text-chocolate-900 font-bold text-xs px-3 py-1 rounded-bl-lg" data-id="element-369">
                GRATIS HOY
              </div>
              <div className="text-4xl flex-shrink-0" data-id="element-370">{bono.emoji}</div>
              <div className="flex-grow" data-id="element-371">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-2 mt-2 md:mt-0" data-id="element-372">
                  <h3 className="text-xl font-bold text-chocolate-900" data-id="element-373">
                    {bono.title}
                  </h3>
                  <span className="text-chocolate-800/60 font-medium line-through" data-id="element-374">
                    Valor: <PriceDisplay amount={bono.value} data-id="element-375" />
                  </span>
                </div>
                <ul className="space-y-2" data-id="element-376">
                  {bono.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start space-x-2 text-chocolate-800" data-id="element-377">
                      <span className="text-gold-500 mt-1" data-id="element-378">•</span>
                      <span data-id="element-379">{bullet}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}